// api.js
const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:4000";

// Token storage
let memoryToken = localStorage.getItem("auth_token") || null;

export function setToken(token) {
    memoryToken = token;
    if (token) {
        localStorage.setItem("auth_token", token);
    } else {
        localStorage.removeItem("auth_token");
    }
}

export function getToken() {
    return memoryToken;
}

export function clearToken() {
    memoryToken = null;
    localStorage.removeItem("auth_token");
}

// Fetch wrapper
export async function apiFetch(path, options = {}) {
    // headers:
    // content-Type + auth token + any caller overrides
    const headers = {
        "Content-Type": "application/json",
    };

    if (memoryToken) {
        headers["Authorization"] = `Bearer ${memoryToken}`;
    }

    if (options.headers) {
        Object.assign(headers, options.headers);
    }

    // build
    const fetchOptions = {
        method: options.method || "GET",
        headers,
    };

    // Only attach body for non-GET requests
    if (options.body) {
        fetchOptions.body = options.body;
    }

    const res = await fetch(`${API_BASE}${path}`, fetchOptions);

    if (res.status === 401) {
        clearToken();
    }

    if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        const err = new Error(body.error || `API error: ${res.status}`);
        err.status = res.status;
        throw err;
    }

    return res.json();
}